export default __webpack_public_path__ + "static/media/m-redcaviar.596ab69c.png";